import { Tab, TabList, TabPanel, Tabs, theme } from '@tryhackme/thm-ui-components';
import { AzureSectionProps, TabOptions } from '../azure-cloud-details-modal.types';
import { LabActions } from './lab-actions';
import { AzureCredentials } from './azure-credentials';
import { AzureEnvironment } from './azure-environment';
export const AzureTabs = ({
  lab,
  formattedExpiry
}: AzureSectionProps) => <Tabs defaultValue={TabOptions.ENVIRONMENT} data-sentry-element="Tabs" data-sentry-component="AzureTabs" data-sentry-source-file="azure-tabs.tsx">
    <TabList alignment="left" data-sentry-element="TabList" data-sentry-source-file="azure-tabs.tsx">
      <Tab value={TabOptions.ENVIRONMENT} borderbottom={theme.colors.border.light} data-sentry-element="Tab" data-sentry-source-file="azure-tabs.tsx">
        {TabOptions.ENVIRONMENT}
      </Tab>
      {lab?.actions && lab?.actions.length > 0 && <Tab value={TabOptions.ACTIONS} borderbottom={theme.colors.border.light}>
          {TabOptions.ACTIONS}
        </Tab>}
      <Tab value={TabOptions.CREDENTIALS} borderbottom={theme.colors.border.light} data-sentry-element="Tab" data-sentry-source-file="azure-tabs.tsx">
        {TabOptions.CREDENTIALS}
      </Tab>
      <TabPanel value={TabOptions.ENVIRONMENT} data-sentry-element="TabPanel" data-sentry-source-file="azure-tabs.tsx">
        <AzureEnvironment lab={lab} formattedExpiry={formattedExpiry} data-sentry-element="AzureEnvironment" data-sentry-source-file="azure-tabs.tsx" />
      </TabPanel>
      {lab?.actions && lab?.actions.length > 0 && <TabPanel value={TabOptions.ACTIONS}>
          <LabActions actions={lab?.actions ?? []} labId={lab?._id} taskId={lab?.taskId} roomId={lab?.roomId} disableActions={false} />
        </TabPanel>}
      <TabPanel value={TabOptions.CREDENTIALS} data-sentry-element="TabPanel" data-sentry-source-file="azure-tabs.tsx">
        <AzureCredentials lab={lab} formattedExpiry={formattedExpiry} data-sentry-element="AzureCredentials" data-sentry-source-file="azure-tabs.tsx" />
      </TabPanel>
    </TabList>
  </Tabs>;